<!-- eslint-disable vue/require-v-for-key -->
<template>
  <base-modal
    id="product-detail"
    size="modal-detail"
    title=" "
    :show="show"
    centered
    @closed="close()"
  >
    <template v-if="product">
      <div class="main">
        <div v-if="product.images.length >= 4" class="image-part">
          <div class="image-selector">
            <div :class="{ 'hidden': imageIndex == 0, 'image-scroll': true, 'arrow' : true }" @click="scrollLeft()">
              <base-icon icon="right-arrow-cell" style="transform: rotate(180deg);" />
            </div>
            <img class="image" :src="product.images[imageIndex].image_url">
            <div :class="{ 'hidden': imageIndex == product.images.length - 1, 'image-scroll': true, 'arrow' : true }" @click="scrollRight()">
              <base-icon icon="right-arrow-cell" />
            </div>
          </div>
          <div class="d-flex" style="margin: 5px 40px 0px 40px;">
            <div v-for="(n, i) in 4" :key="`carousel-image-${i}`" @click="myMethod(imageIndex + i)">
              <img
                class="image image-carousel" :src="product.images[imageIndex + i].image_url"
              >
            </div>
          </div>
        </div>
        <!-- not valid image product -->
        <div v-else class="image-part">
          <div v-if="product.images.length == 0 " class="image-selector">
            <img class="image" src="/img/blank-product.png">
          </div>
          <div v-else class="image-selector">
            <img class="image" :src="product.images[imageIndex].image_url">
          </div>
          <div v-if=" product.images && product.images.length > 1" class="d-flex">
            <div v-for="(n, i) in product.images.length" :key="`carousel-image-${i}`" @click="myMethod(imageIndex + i)">
              <img
                class="image image-carousel-limit" :src="product.images[imageIndex + i].image_url"
              >
            </div>
          </div>
          <div v-else class="d-flex" style="margin: 5px 40px 0px 40px;">
            <div v-for="(n, i) in product.images.length" :key="`carousel-image-${i}`" @click="myMethod(imageIndex + i)">
              <img
                v-if="product.images.length> 1"
                class="image image-carousel" src="/img/blank-product.png"
              >
              <div
                v-else class="image image-carousel" style="width: 115px;"
              />
            </div>
          </div>
        </div>

        <div class="info-container">
          <div v-if="!isMonobrand" class="title">
            {{ product.title }}
          </div>
          <div v-else>
            <div class="title">
              {{ product.brand.name }}
            </div>
            <div class="subtitle">
              {{ product.title }}
            </div>
          </div>
          <div class="price">
            {{ product.formatted_price }}
          </div>

          <div v-if="product.stock_state === 'on_sale' && product.sale_price" class="price__sale">
            {{ product.formatted_sale_price }}
          </div>

          <div class="sku">
            ID: {{ product.external_id }}
          </div>
          <div v-if="product.color" class="section">
            <div class="section-title">
              Color:
            </div>
            <div class="section-body">
              {{ product.color.join() }}
            </div>
          </div>

          <div v-if="product.size_info" class="section">
            <div class="section-title">
              Size:
            </div>
            <div class="section-body">
              {{ product.size_info }}
            </div>
          </div>
          <div v-if="product.season && product.season.length" class="section">
            <div class="section-title">
              Season:
            </div>
            <div class="section-body">
              {{ product.season[0] }}
            </div>
          </div>

          <div v-if="product.stock_status" class="section">
            <div class="section-title">
              Stock Status
            </div>
            <div class="section-body">
              {{ product.stock_status }}
            </div>
          </div>
          <div v-if="product.description" class="section">
            <div style="display: flex; justify-content: space-between;">
              <div class="section-title mt-4">
                Description
              </div>
              <button
                data-toggle="collapse"
                data-target="#demo" style="border: none; background: none; margin-top:10px"
                @click="visibleDescrip = !visibleDescrip"
              >
                <base-icon icon="chevron-down-black" :style="`${ visibleDescrip ? 'transform: rotate(180deg)' : ''}`" />
              </button>
            </div>
            <div id="demo" class="section-body collapse">
              <div v-html="product.description ? product.description : '-'" />
            </div>
            <hr>
          </div>
          <div class="section">
            <div class="section-title__URL" style="font-size: 16px; font-family: 'SilkaMedium';">
              URL
              <base-text
                underline
                style="
                font-family: 'SilkaLight';
                cursor: pointer;
                font-size: 12px;"
                @click="onCopyLinkClicked"
              >
                Copy URL
              </base-text>
            </div>
            <div class="section-body">
              <a class="link" :href="product.site_url" target="_blank">{{ product.site_url }}</a>
              <input id="site-url" type="hidden" :value="product.site_url">
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
export default {
  name: 'CatalogProductDetailModal',
  props: {
    product: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
    },
  },
  data: () => ({
    imageIndex: 0,
    visibleDescrip: false,
  }),
  computed: {
    isMonobrand() {
      return this.$store?.state?.account?.user?.profile?.institution?.is_monobrand;
    },
  },
  methods: {
    onCopyLinkClicked() {
      const testingCodeToCopy = document.querySelector('#site-url');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        // alert('Oops, unable to copy');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    close() {
      this.visibleDescrip = true;
      this.imageIndex = 0;
      this.$emit('closed');
    },
    scrollLeft() {
      this.imageIndex--;
    },
    scrollRight() {
      this.imageIndex++;
    },
    myMethod(ssps) {
      this.imageIndex = ssps;
    },

  },
};
</script>

<style lang="scss" scoped>
  .hidden {
    visibility: hidden;
  }
  .arrow {
    background-color: unset !important;
  }

  .main {
    display: flex;
    flex-direction:row;
    margin-top: 12px;
    margin-bottom: 12px;
    width: 100%;
    & > * {
      flex: 1;

      &:not(:first-child) {
        padding-left: 32px;
      }
    }
  }

  .image {
    min-width: 0;
    width: 426px;
    max-width: 426px;
    max-height: 500px;
  }

  .link:hover {
    background-color: transparent;
  }

  .image-selector {
    display: flex;
    flex-direction: row;
    max-width:100%;
    & > * {

      &:not(:first-child) {
        margin-left: 10px;
      }
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .image-scroll {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;

    &:hover {
      background: #f7f7f7;
    }
  }

  .link {
    margin-top: 30px;
  }

  .title {
    font-family: Tiempos;
    font-size: 27px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .section-title {
    font-family: 'SilkaMedium';
    font-size: 14px;
    margin-bottom: 8px;

    &__URL {
      display:flex;
      flex-direction:row;
      justify-content: space-between;
    }

  }
  .section-body {
    font-family: 'SilkaLight';
    font-size: 14px;
    margin-bottom: 16px;
    overflow-wrap: break-word;
  }

  .section {
    margin-bottom: 16px;

  }

  .price {
    font-family: 'SilkaLight';
    margin-bottom: 12px;
    &__sale{
      color: #DA1E28;
      margin-bottom: 12px;

    }
  }
  .image-part{
    max-width: 546px;
    flex: 56;
    max-width: 56%;
    display:flex;
    flex-direction:column;
    align-items:center;
  }
  .sku {
    margin-bottom: 24px;
  }
  .sku {
    color: #767676;
    font-family: 'SilkaLight';
    font-weight: 300;
    font-size: 0.75rem;
  }
  ::v-deep .modal-header{
    background-color: unset;
    z-index: 9999;
    border-bottom: none;
    .close {
      padding: 20px 22px 14px 0px;
    }
    height: 56px;
  }
  ::v-deep .modal-content{
    padding: unset;
    max-width: 1118px;
    width:87.5vw;
    height: 92.5vh;
    max-height: 768px;
  }
  ::v-deep .modal-body{
    padding: 0 56px 50px 56px !important;
  }
  .image-carousel{
    max-width: 111.5px;
    padding: 5px;
    cursor: pointer;
  }
  .image-carousel-limit{
    max-width: 111.5px;
    padding-top: 10px;
    padding-right: 10px;
    cursor: pointer;
  }
  .subtitle{
    font-size: 16px;
    font-weight: 300;
    color: #1B1B1B;
    margin-bottom: 8px;
  }
  .info-container{
    flex: 1;
    max-width: 46%;
  }
</style>
